import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {Text, View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

import {
    backgroundBlobDesktopHeight,
    backgroundBlobMobileHeight,
} from "./background-blob.tsx";
import Illustration from "./illustration.tsx";
import {SerifQuote} from "./typography/typography.ts";

type Props = {
    kind: "Testimonial";
    quote: string;
    attribution: string;
    meta: string;
    illustration?: string;
    backgroundIllustration?: string;
    staticGraphic?: string;
};

export default class Quote extends React.Component<Props> {
    render(): React.ReactNode {
        const {
            quote,
            attribution,
            meta,
            illustration,
            backgroundIllustration,
            staticGraphic,
        } = this.props;

        return (
            <View style={styles.testimonial}>
                {backgroundIllustration && (
                    <Illustration name={backgroundIllustration} />
                )}
                <View style={styles.container}>
                    <View style={styles.content}>
                        <SerifQuote style={styles.quote}>{quote}</SerifQuote>
                        <View
                            style={[
                                styles.attributionContainer,
                                !illustration &&
                                    !staticGraphic &&
                                    styles.attributionContainerNoGraphic,
                            ]}
                        >
                            {illustration && (
                                <View style={styles.illustration}>
                                    <Illustration name={illustration} />
                                </View>
                            )}
                            {!illustration && staticGraphic && (
                                <View style={styles.illustration}>
                                    <img
                                        className={css(styles.img)}
                                        alt=""
                                        src={staticUrl(staticGraphic)}
                                    />
                                </View>
                            )}
                            <View style={styles.attributionCopy}>
                                <Text style={styles.attribution}>
                                    {attribution}
                                </Text>
                                <Text
                                    style={
                                        (styles.attribution,
                                        styles.attributionMeta)
                                    }
                                >
                                    {meta}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    testimonial: {
        // temp fix for Ajali testimonial on LOHP
        margin: "-80px 0 80px 0",
        [mediaQueries.mdOrSmaller]: {
            marginTop: 0,
        },
    },
    illustration: {
        margin: "16px auto",
        width: 160,
        padding: "16px 14px",
        [mediaQueries.smOrSmaller]: {
            width: 130,
        },
    },
    img: {
        width: "100%",
        height: "auto",
    },
    attributionContainer: {
        flexDirection: "row-reverse",
        alignItems: "center",
    },
    attributionContainerNoGraphic: {
        marginTop: 40,
    },
    container: {
        alignItems: "center",
        justifyContent: "center",
        // This matches the height of the background
        minHeight: backgroundBlobDesktopHeight,
        padding: "0 64px",
        width: "100%",
        [mediaQueries.mdOrSmaller]: {
            // This matches the height of the background
            minHeight: backgroundBlobMobileHeight,
            paddingLeft: 112,
            paddingRight: 112,
        },
        [mediaQueries.smOrSmaller]: {
            paddingLeft: 48,
            paddingRight: 48,
            paddingTop: 24,
        },
    },
    content: {
        maxWidth: 1020,
        margin: "110px auto 0",
        flexDirection: "column",
    },
    quote: {
        flex: 1,
        textIndent: "-0.35em",
    },
    attributionCopy: {
        flex: 1,
        alignItems: "flex-end",
        marginRight: 24,

        [mediaQueries.smOrSmaller]: {
            marginRight: 0,
            marginLeft: 12,
        },
    },

    // non-WB Lato font styling
    attribution: {
        fontSize: 13,
        lineHeight: "25px",
        letterSpacing: "0.1em",
        fontWeight: 700,
        textAlign: "center",

        [mediaQueries.lgOrLarger]: {
            fontSize: 16,
            lineHeight: "25px",
            letterSpacing: "0.1em",
        },
    },

    attributionMeta: {
        fontStyle: "italic",
        textAlign: "center",
        textTransform: "uppercase",
    },
});
